import apiClient from "./apiClient";

export const getUserDetails = async (email: string) => {
  try {
    const response = await apiClient.get(`/users/userdetails`, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user details", error);
    throw error;
  }
};

export const updateUserDetails = async (id: string, data: UserData) => {
  try {
    const response = await apiClient.put(`/users/updateUser/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating user details", error);
    throw error;
  }
};

export const getUserAssociatedBrand = async (userId: string) => {
  try {
    const response = await apiClient.get(`useraccess/getAccessbyuser/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user details", error);
    throw error;
  }
};

export const getBrandOrders = async (brandId: string): Promise<Order[]> => {
  try {
    const response = await apiClient.get(`/useraccess/getOrderbyBrandid/${brandId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user details", error);
    throw error;
  }
};

export const fetchProductByIdApi = async (id: string) => {
  const response = await apiClient.get(`/products/getbyid/${id}`);
  return response.data;
};

export const fetchOrderDetailsByIdApi = async (id: string): Promise<OrderDetails> => {
  const response = await apiClient.get(`/useraccess/orderDetails/${id}`);
  return response.data;
};

export const updateShipmentsApi = async (orderId: string, payload: any): Promise<ShipmentData> => {
  const response = await apiClient.put(`/shipment/updateshipments/${orderId}`,payload);
  return response.data;
};

export const fetchProductsByBrandIdApi = async (brandId: string) => {
  const response = await apiClient.get(`/products/getProductsByBrandId/${brandId}`);
  return response.data;
};

export const fetchCategories = async () => {
  try {
    const response = await apiClient.get('/categories/getCategory');
    return response.data;
  } catch (error) {
    console.error("Error fetching categories", error);
    throw error;
  }
};

export const updateProduct = async (productId: string, formData: FormData) => {
  try {
    const response = await apiClient.put(`/products/updateProduct/${productId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};